/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
// ---------------------------------------------------------------------------------------------
// EPOD Phase 4 - AL Review (Action 16), Escalation (Action 17, no direct UI - it is Python-cron-
// triggered), Document Generation/Access (Action 18), and Signed Document Upload (Action 19 -
// WEB-026..038).
//
// Document access is NOT enforced here - the Generate/View/Upload-Signed buttons are shown when
// the backend's own options say the feature is on; the actual per-role access rule (Dealer never
// sees a Credit Note, LSP/Dealer only their own LR, ONLY the LSP may upload a signed document) is
// re-validated server-side on every document-related call regardless of what this screen renders.
//
// A genuinely new screen for a genuinely new audience action - deliberately NOT added to
// epodScreen.js (already 2900+ lines and a different job: managing e-POD uploads and the
// Phase 2 late-upload gate) and NOT added to dealerConfirmationScreen.js (the dealer's own
// screen). This mirrors the same "one focused screen per distinct job" precedent Phase 3 itself
// established.
//
// Backend is authoritative regardless of what this screen shows - approval_actions,
// require_reject_remarks, require_ndv_amount_on_approve and the Credit-Note/COF boundary are all
// re-validated server-side on the actual /billing/alReviewAction call.
// ---------------------------------------------------------------------------------------------
import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import SweetAlert from 'react-bootstrap-sweetalert';
import { getWorkflowDisplayStatus, STATUS_BADGE_CLASS } from "./workflowStatus";
var moment = require('moment');
var redirectURL = require('../redirectURL');
var { withDeptCode } = require('../common/deptCode'); // SLA hints for the page's ?dept_code (none = SPD)

const authHeaders = () => ({ headers: { 'Authorization': localStorage.getItem("userid") } });

function fmtDate(v) {
    if (!v) return '';
    try { return moment(v).format('DD-MMM-YYYY HH:mm'); } catch (e) { return ''; }
}

// Display-only. The next level and the time left come from the server
// (alReviewService.escalationSchedule - the SAME schedule escalatePendingReviews acts on), so the
// screen follows each level's epod_sla value, unit and Sunday/holiday switches without recomputing
// anything here. Accurate as of when the grid was loaded.
function slaRemainingText(row) {
    if (row.dealer_confirmation_status !== 'pending_al_review') return '-';
    var currentLevel = Number(row.escalation_level) || 0;
    if (row.escalation_final) return currentLevel > 0 ? 'Escalated (Level ' + currentLevel + ', final)' : '-';
    if (!row.escalation_next_level || row.escalation_hours_remaining === null || row.escalation_hours_remaining === undefined) return '-';
    if (row.escalation_hours_remaining <= 0) return 'Due for Level ' + row.escalation_next_level;
    var prefix = currentLevel > 0 ? 'Escalated (Level ' + currentLevel + ') - ' : '';
    return prefix + Math.floor(row.escalation_hours_remaining) + 'h to Level ' + row.escalation_next_level;
}

export default class AlReviewScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: [],
            loading: false,
            show: false, basicTitle: '', basicType: 'success',
            options: {
                enabled: false, approval_actions: { approve: false, reject: false },
                require_reject_remarks: true, require_ndv_amount_on_approve: true,
                max_remarks_length: 500, ndv_credit_note_max: 3500,
                document_generation_enabled: false,
                signed_upload: { enabled: false, window_days: 7, allowed_mime_types: [], max_size_mb: 10 },
                escalation: { enabled: false, reference_timestamp_field: 'submitted_at', levels: [] },
            },

            reviewModalShow: false, reviewRow: null, reviewAction: null,
            reviewRemarks: '', reviewNdvAmount: '', reviewDetail: null,
            reviewSubmitting: false, reviewError: '', reviewDetailLoading: false,
            reviewDamageFiles: [], reviewDamageFilesLoading: false,

            // Action 18 - Document generation/view state, per-row
            docBusyRowId: null, docError: '',

            // Action 19 - Signed document upload modal state
            signedUploadModalShow: false, signedUploadRow: null, signedUploadFile: null,
            signedUploadSubmitting: false, signedUploadError: '',
        };
    }

    componentDidMount() {
        this.loadOptions();
        this.loadQueue();
    }

    loadOptions = () => {
        redirectURL.post("/billing/alReviewOptions", withDeptCode({}), authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") this.setState({ options: resp.data });
            })
            .catch(() => { /* fail closed - options stay at the disabled default */ });
    }

    loadQueue = () => {
        this.setState({ loading: true });
        redirectURL.post("/billing/alReviewQueue", {}, authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({ rowData: resp.data.rows || [], loading: false });
                } else {
                    this.setState({ loading: false, show: true, basicType: "danger", basicTitle: (resp.data && resp.data.message) || "Failed to load queue" });
                }
            })
            .catch((err) => {
                this.setState({ loading: false, show: true, basicType: "danger", basicTitle: (err.response && err.response.data && err.response.data.message) || "Failed to load queue" });
            });
    }

    closeAlert = () => { this.setState({ show: false }); }

    onClickReview = (row, action) => {
        this.setState({
            reviewModalShow: true, reviewRow: row, reviewAction: action,
            reviewRemarks: '', reviewNdvAmount: '', reviewDetail: null, reviewError: '', reviewSubmitting: false,
            reviewDetailLoading: true,
        });
        redirectURL.post("/billing/alReviewDetail", { rowid: row._id }, authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var confirmation = resp.data.confirmation;
                    // BRD WEB-018/019/026 - NDV is dealer-entered; when this confirmation has one
                    // (every confirmation submitted since that shipped), pre-fill it as a
                    // read-only compatibility value for the request - the reviewer never types
                    // over it (see render() below, which only shows an editable box when this is
                    // null, for pre-existing confirmations from before dealer-entered NDV shipped).
                    var dealerNdv = confirmation && confirmation.ndv && confirmation.ndv.amount;
                    this.setState({
                        reviewDetail: confirmation, reviewDetailLoading: false,
                        reviewNdvAmount: (dealerNdv !== undefined && dealerNdv !== null) ? String(dealerNdv) : '',
                    });
                } else this.setState({ reviewDetailLoading: false });
            })
            .catch(() => { this.setState({ reviewDetailLoading: false }); });
    }
    onCancelReview = () => {
        this.setState({ reviewModalShow: false, reviewRow: null, reviewAction: null, reviewRemarks: '', reviewNdvAmount: '', reviewDetail: null, reviewError: '', reviewSubmitting: false, reviewDamageFiles: [] });
    }
    // Reuses the exact same ownership-checked endpoint the "Damage Files" column on /epodScreen
    // already uses (dealerConfirmationService.getDamageFiles / resolveDamageFilesAccess) - no new
    // storage/download mechanism. AL reviewers pass that check the same way Admin already does.
    onClickViewReviewDamageFiles = () => {
        if (!this.state.reviewRow || this.state.reviewDamageFilesLoading) return;
        this.setState({ reviewDamageFilesLoading: true });
        redirectURL.post("/billing/dealerDamageFiles", { rowid: this.state.reviewRow._id }, authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({ reviewDamageFiles: resp.data.files || [], reviewDamageFilesLoading: false });
                } else {
                    this.setState({ reviewDamageFilesLoading: false, show: true, basicType: "danger", basicTitle: (resp.data && resp.data.message) || 'Could not load damage files.' });
                }
            })
            .catch((err) => {
                this.setState({ reviewDamageFilesLoading: false, show: true, basicType: "danger", basicTitle: (err.response && err.response.data && err.response.data.message) || 'Could not load damage files.' });
            });
    }
    onChangeReviewRemarks = (e) => {
        var v = e.target.value;
        var maxLen = this.state.options.max_remarks_length || 500;
        if (v.length > maxLen) v = v.substring(0, maxLen);
        this.setState({ reviewRemarks: v, reviewError: '' });
    }
    onChangeReviewNdvAmount = (e) => {
        this.setState({ reviewNdvAmount: e.target.value, reviewError: '' });
    }
    onConfirmReview = () => {
        var { reviewRow, reviewAction, reviewRemarks, reviewNdvAmount, reviewDetail, options } = this.state;
        var trimmed = (reviewRemarks || '').trim();
        if (reviewAction === 'reject' && options.require_reject_remarks && !trimmed) {
            this.setState({ reviewError: 'Rejection remarks are required.' });
            return;
        }
        // BRD WEB-018/019/026 - NDV is dealer-entered. When the dealer's confirmation already has
        // one, it's read-only here (see render()) and always valid, so no client-side check is
        // needed for that case. The editable fallback (pre-existing confirmations with no
        // ndv.amount) keeps the exact old validation.
        var dealerHasNdv = reviewDetail && reviewDetail.ndv && reviewDetail.ndv.amount !== undefined && reviewDetail.ndv.amount !== null;
        if (reviewAction === 'approve' && !dealerHasNdv && options.require_ndv_amount_on_approve && (reviewNdvAmount === '' || isNaN(Number(reviewNdvAmount)) || Number(reviewNdvAmount) < 0)) {
            this.setState({ reviewError: 'A valid, non-negative NDV amount is required to approve.' });
            return;
        }
        this.setState({ reviewSubmitting: true, reviewError: '' });
        redirectURL.post("/billing/alReviewAction", {
            rowid: reviewRow._id, action: reviewAction, remarks: trimmed,
            ndv_amount: reviewAction === 'approve' && reviewNdvAmount !== '' ? Number(reviewNdvAmount) : undefined,
        }, authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    // A successful Reject is still a successful API call - never treated as a
                    // failure - but rendered with the existing red/danger alert style since the
                    // business RESULT is a rejection; a successful Approve stays green.
                    this.setState({
                        reviewModalShow: false, reviewRow: null, reviewAction: null, reviewRemarks: '', reviewNdvAmount: '', reviewDetail: null, reviewSubmitting: false, reviewError: '',
                        show: true, basicType: reviewAction === 'reject' ? "danger" : "success", basicTitle: resp.data.message || "Review recorded.",
                    });
                    this.loadQueue();
                } else {
                    this.setState({ reviewSubmitting: false, reviewError: (resp.data && resp.data.message) || 'Review failed.' });
                    // BRD WEB-032 - "AL Team is shown the latest value": on exactly this conflict,
                    // immediately re-pull the dealer's current NDV so the reviewer sees it without
                    // having to close and reopen the modal themselves.
                    if (resp.data && resp.data.code === 'ndv_value_changed') this.refreshReviewDetail();
                }
            })
            .catch((err) => {
                var data = err.response && err.response.data;
                this.setState({ reviewSubmitting: false, reviewError: (data && data.message) || 'Review failed.' });
                if (data && data.code === 'ndv_value_changed') this.refreshReviewDetail();
            });
    }
    // Re-fetches the dealer's current confirmation detail into the still-open review modal -
    // used after an ndv_value_changed conflict so the reviewer sees the latest NDV immediately.
    refreshReviewDetail = () => {
        var { reviewRow } = this.state;
        if (!reviewRow) return;
        redirectURL.post("/billing/alReviewDetail", { rowid: reviewRow._id }, authHeaders())
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    var confirmation = resp.data.confirmation;
                    var dealerNdv = confirmation && confirmation.ndv && confirmation.ndv.amount;
                    this.setState({
                        reviewDetail: confirmation,
                        reviewNdvAmount: (dealerNdv !== undefined && dealerNdv !== null) ? String(dealerNdv) : '',
                    });
                }
            })
            .catch(() => { /* the reviewer can still Cancel and reopen manually */ });
    }

    // ---- Action 18: Document Generation / View ---------------------------------------------------
    // Backend is authoritative for access regardless of what this button shows - a caller who
    // isn't allowed to see this document type still gets a clean, server-enforced denial.
    onClickGenerateDocument = (row) => {
        this.setState({ docBusyRowId: row._id, docError: '' });
        redirectURL.post("/billing/alReviewDocumentGenerate", { rowid: row._id }, authHeaders())
            .then((resp) => {
                this.setState({ docBusyRowId: null });
                if (resp.data && resp.data.status === "success") {
                    this.setState({ show: true, basicType: "success", basicTitle: resp.data.message || ('Document generated (' + resp.data.document_number + ').') });
                    this.loadQueue();
                } else {
                    this.setState({ show: true, basicType: "danger", basicTitle: (resp.data && resp.data.message) || 'Document generation failed.' });
                }
            })
            .catch((err) => {
                this.setState({ docBusyRowId: null, show: true, basicType: "danger", basicTitle: (err.response && err.response.data && err.response.data.message) || 'Document generation failed.' });
            });
    }
    onClickViewDocument = (row) => {
        this.setState({ docBusyRowId: row._id, docError: '' });
        redirectURL.post("/billing/alReviewDocumentDownload", { rowid: row._id }, authHeaders())
            .then((resp) => {
                this.setState({ docBusyRowId: null });
                if (resp.data && resp.data.status === "success" && resp.data.url) {
                    window.open(resp.data.url, '_blank');
                } else {
                    this.setState({ show: true, basicType: "danger", basicTitle: (resp.data && resp.data.message) || 'You are not authorized to view this document.' });
                }
            })
            .catch((err) => {
                this.setState({ docBusyRowId: null, show: true, basicType: "danger", basicTitle: (err.response && err.response.data && err.response.data.message) || 'Unable to open the document.' });
            });
    }

    // ---- Action 19: Signed Document Upload ------------------------------------------------------
    // Backend is authoritative - only the LR's own transporter (LSP), or Admin, will ever succeed;
    // this modal is shown to anyone with document_generation + signed_upload enabled, and the
    // actual /alReviewDocumentSignedUpload call re-validates authorization independently.
    onClickUploadSigned = (row) => {
        this.setState({ signedUploadModalShow: true, signedUploadRow: row, signedUploadFile: null, signedUploadError: '', signedUploadSubmitting: false });
    }
    onCancelSignedUpload = () => {
        this.setState({ signedUploadModalShow: false, signedUploadRow: null, signedUploadFile: null, signedUploadError: '', signedUploadSubmitting: false });
    }
    onChangeSignedFile = (e) => {
        this.setState({ signedUploadFile: (e.target.files && e.target.files[0]) || null, signedUploadError: '' });
    }
    onConfirmSignedUpload = () => {
        var { signedUploadRow, signedUploadFile } = this.state;
        if (!signedUploadFile) { this.setState({ signedUploadError: 'Please select a file to upload.' }); return; }
        this.setState({ signedUploadSubmitting: true, signedUploadError: '' });
        var formData = new FormData();
        formData.append('rowid', signedUploadRow._id);
        formData.append('signed_document', signedUploadFile);
        redirectURL.post("/billing/alReviewDocumentSignedUpload", formData, {
            headers: { 'content-type': 'multipart/form-data', 'Authorization': localStorage.getItem("userid") }
        })
            .then((resp) => {
                if (resp.data && resp.data.status === "success") {
                    this.setState({
                        signedUploadModalShow: false, signedUploadRow: null, signedUploadFile: null, signedUploadSubmitting: false, signedUploadError: '',
                        show: true, basicType: "success", basicTitle: resp.data.message || "Signed document uploaded.",
                    });
                    this.loadQueue();
                } else {
                    this.setState({ signedUploadSubmitting: false, signedUploadError: (resp.data && resp.data.message) || 'Upload failed.' });
                }
            })
            .catch((err) => {
                this.setState({ signedUploadSubmitting: false, signedUploadError: (err.response && err.response.data && err.response.data.message) || 'Upload failed.' });
            });
    }
    onClickViewSignedDocument = (row) => {
        this.setState({ docBusyRowId: row._id });
        redirectURL.post("/billing/alReviewDocumentSignedDownload", { rowid: row._id }, authHeaders())
            .then((resp) => {
                this.setState({ docBusyRowId: null });
                if (resp.data && resp.data.status === "success" && resp.data.url) {
                    window.open(resp.data.url, '_blank');
                } else {
                    this.setState({ show: true, basicType: "danger", basicTitle: (resp.data && resp.data.message) || 'You are not authorized to view this document.' });
                }
            })
            .catch((err) => {
                this.setState({ docBusyRowId: null, show: true, basicType: "danger", basicTitle: (err.response && err.response.data && err.response.data.message) || 'Unable to open the document.' });
            });
    }

    render() {
        var { rowData, options } = this.state;
        var actions = options.approval_actions || {};
        var columnDefs = [
            { headerName: "GC/Way Bill No", field: "gc_waybill_no", width: 140 },
            { headerName: "Dealer", field: "consignee_name", width: 180 },
            { headerName: "Condition", field: "dealer_confirmation_condition", width: 110, valueGetter: (p) => p.data.dealer_confirmation_condition || '-' },
            {
                // Read-only for AL - the persisted Dealer-submitted value only, never editable here
                // (WEB-032's own guard rejects an approve against a value that has since changed).
                headerName: "Dealer Submitted NDV", field: "ndv_amount", width: 170,
                valueGetter: (p) => (p.data.ndv_amount !== undefined && p.data.ndv_amount !== null) ? 'Rs. ' + p.data.ndv_amount : '-',
            },
            {
                headerName: "Shortage Qty", field: "shortage_quantity", width: 120,
                valueGetter: (p) => (p.data.dealer_confirmation_condition === 'shortage' && p.data.shortage_quantity !== undefined && p.data.shortage_quantity !== null) ? p.data.shortage_quantity : '-',
            },
            {
                headerName: "Damage Documents", field: "damage_files_count", width: 150,
                valueGetter: (p) => (p.data.dealer_confirmation_condition === 'damage' && p.data.damage_files_count) ? p.data.damage_files_count + ' file(s)' : '-',
            },
            { headerName: "Submitted At", field: "submitted_at", width: 160, valueGetter: (p) => fmtDate(p.data.submitted_at) },
            {
                headerName: "SLA Remaining", field: "sla_remaining", width: 190,
                valueGetter: (p) => slaRemainingText(p.data),
            },
            {
                headerName: "Escalation Level", field: "escalation_level", width: 130,
                valueGetter: (p) => p.data.escalation_level ? 'Level ' + p.data.escalation_level : '-',
            },
            {
                // Reuses the SAME centralized resolver epodScreen.js's own "Workflow Status" column
                // uses (workflowStatus.js) - previously a narrower, local mapping here (only ever
                // said "AL Approved (condition)"/"AL Rejected (condition)"/"Pending AL Review
                // (condition)", never reflecting document generation/signed upload progress at all,
                // and never distinguishing terminal vs legacy rejection). Condition itself is still
                // its own separate "Condition" column above, so no detail is lost by dropping it
                // from this text.
                headerName: "Status", field: "dealer_confirmation_status", width: 240,
                valueGetter: (p) => getWorkflowDisplayStatus(p.data).text,
                cellRenderer: (params) => {
                    var resolved = getWorkflowDisplayStatus(params.data);
                    var span = document.createElement('span');
                    span.className = STATUS_BADGE_CLASS[resolved.style] || STATUS_BADGE_CLASS.secondary;
                    span.innerText = resolved.text;
                    return span;
                },
            },
            {
                // AL's own approve/reject remarks - previously persisted (al_review.remarks) but not
                // surfaced anywhere in this grid; only ever reached the Dealer via the rejection email.
                headerName: "AL Remarks", field: "al_review_remarks", width: 220,
                valueGetter: (p) => (p.data.dealer_confirmation_status === 'al_rejected' || p.data.dealer_confirmation_status === 'al_approved') ? (p.data.al_review_remarks || '-') : '-',
            },
            { headerName: "Confirmed At", field: "dealer_confirmed_at", width: 160, valueGetter: (p) => fmtDate(p.data.dealer_confirmed_at) },
            {
                headerName: "Document", field: "epod_document_type", width: 150,
                valueGetter: (p) => p.data.epod_document_id ? (p.data.epod_document_type === 'credit_note' ? 'Credit Note' : 'COF') + ' (' + (p.data.epod_document_status || 'generated') + ')' : '-',
            },
            {
                headerName: "Signed Doc", field: "epod_signed_document_status", width: 130,
                valueGetter: (p) => p.data.epod_document_id ? (p.data.epod_signed_document_status || 'pending') : '-',
            },
            {
                headerName: "Action", field: "action", width: 340, pinned: "right",
                cellRenderer: (params) => {
                    var wrap = document.createElement('span');
                    var mk = (label, cls, handler) => {
                        var b = document.createElement('button');
                        b.className = cls; b.style.padding = '2px 8px'; b.style.fontSize = '12px'; b.style.marginRight = '4px';
                        b.innerText = label;
                        b.disabled = this.state.docBusyRowId === params.data._id;
                        b.onclick = (e) => { e.stopPropagation(); handler(params.data); };
                        wrap.appendChild(b);
                    };

                    if (params.data.dealer_confirmation_status === 'pending_al_review') {
                        if (actions.approve) mk('Approve', 'btn btn-success', (row) => this.onClickReview(row, 'approve'));
                        if (actions.reject) mk('Reject', 'btn btn-danger', (row) => this.onClickReview(row, 'reject'));
                        return wrap;
                    }

                    // Action 18 - only ever shown for an AL-approved row; Rejected has no document.
                    if (params.data.dealer_confirmation_status === 'al_approved' && options.document_generation_enabled) {
                        if (params.data.epod_document_id) {
                            mk('View Document', 'btn btn-outline-primary', this.onClickViewDocument);
                            // Action 19 - only once a document actually exists to be signed.
                            if (options.signed_upload.enabled) {
                                if (params.data.epod_signed_document_status === 'signed_uploaded') {
                                    mk('View Signed Doc', 'btn btn-outline-success', this.onClickViewSignedDocument);
                                } else {
                                    mk('Upload Signed Doc', 'btn btn-outline-warning', this.onClickUploadSigned);
                                }
                            }
                        } else {
                            mk('Generate Document', 'btn btn-outline-secondary', this.onClickGenerateDocument);
                        }
                    }
                    return wrap;
                }
            },
        ];

        return (
            <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                    <h1 className="col-xl-12 h3 mb-0 text-gray-800">AL Review - NDV Approval</h1>
                </div>

                <SweetAlert show={this.state.show} type={this.state.basicType} title={this.state.basicTitle} onConfirm={this.closeAlert}>
                </SweetAlert>

                {!options.enabled ?
                    <div className="alert alert-warning">AL review is not currently enabled.</div>
                    : null}

                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="ag-theme-balham" style={{ width: '100%', height: '70vh' }}>
                                    <AgGridReact
                                        modules={AllModules}
                                        columnDefs={columnDefs}
                                        rowData={rowData}
                                        defaultColDef={{ resizable: true, sortable: true, filter: true }}
                                        onGridReady={(params) => { this.gridApi = params.api; }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Approve/Reject review modal */}
                {this.state.reviewModalShow ?
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={this.onCancelReview}>
                        <div className="modal-dialog" style={{ maxWidth: 520, width: '90%', margin: 0 }} onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{this.state.reviewAction === 'approve' ? 'Approve NDV' : 'Reject NDV'}</h5>
                                    <button type="button" className="close" onClick={this.onCancelReview} disabled={this.state.reviewSubmitting}><span>&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    {this.state.reviewRow ?
                                        <p className="mb-2">
                                            <b>GC/Way Bill No:</b> {this.state.reviewRow.gc_waybill_no}<br />
                                            <b>Condition:</b> {this.state.reviewRow.dealer_confirmation_condition}
                                        </p>
                                        : null}
                                    {this.state.reviewDetailLoading ? <p className="text-muted">Loading dealer's submission...</p> : null}
                                    {this.state.reviewDetail ?
                                        <div className="alert alert-secondary py-2 px-2 mb-2" style={{ fontSize: '13px' }}>
                                            <div><b>Dealer remarks:</b> {(this.state.reviewDetail.ndv && this.state.reviewDetail.ndv.remarks) || '-'}</div>
                                            {this.state.reviewDetail.condition === 'shortage' && this.state.reviewDetail.ndv && this.state.reviewDetail.ndv.shortage_quantity !== undefined && this.state.reviewDetail.ndv.shortage_quantity !== null ?
                                                <div><b>Shortage quantity:</b> {this.state.reviewDetail.ndv.shortage_quantity}</div>
                                                : null}
                                            {this.state.reviewDetail.ndv && this.state.reviewDetail.ndv.images && this.state.reviewDetail.ndv.images.length ?
                                                <div>
                                                    <b>Damage files:</b> {this.state.reviewDetail.ndv.images.length} file(s) on record
                                                    {' '}
                                                    <button type="button" className="btn btn-sm btn-outline-secondary" style={{ padding: '0px 6px', fontSize: '11px' }}
                                                        onClick={this.onClickViewReviewDamageFiles} disabled={this.state.reviewDamageFilesLoading}>
                                                        {this.state.reviewDamageFilesLoading ? 'Loading...' : 'View / Download'}
                                                    </button>
                                                    {this.state.reviewDamageFiles && this.state.reviewDamageFiles.length ?
                                                        <ul className="mb-0 mt-1" style={{ paddingLeft: '18px' }}>
                                                            {this.state.reviewDamageFiles.map((f, idx) => (
                                                                <li key={idx}>
                                                                    {f.url ? <a href={f.url} target="_blank" rel="noopener noreferrer">{f.file_name}</a> : f.file_name + ' (unavailable)'}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                        : null}
                                                </div>
                                                : null}
                                        </div>
                                        : null}

                                    {this.state.reviewAction === 'approve' ?
                                        <div className="form-group mb-1">
                                            {/* BRD WEB-018/019/026 - NDV is dealer-entered, not AL-entered. When the dealer's
                                                confirmation already has one, it's shown read-only - the reviewer approves/rejects
                                                the dealer's value, never silently replaces it. The editable box below is a
                                                backward-compatibility fallback for confirmations submitted before dealer-entered
                                                NDV existed (no ndv.amount on record) - Node re-validates either way. */}
                                            {this.state.reviewDetail && this.state.reviewDetail.ndv && this.state.reviewDetail.ndv.amount !== undefined && this.state.reviewDetail.ndv.amount !== null ?
                                                <div>
                                                    <label className="mb-0">Dealer Submitted NDV</label>
                                                    <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Rs. {this.state.reviewDetail.ndv.amount}</div>
                                                    <small className="form-text text-muted">
                                                        &le; Rs. {options.ndv_credit_note_max} routes to Credit Note; above routes to COF. If the dealer changes this
                                                        value before you approve, you'll be shown the latest amount and asked to review it again.
                                                    </small>
                                                </div>
                                                :
                                                <div>
                                                    <label>NDV Amount (Rs.) {options.require_ndv_amount_on_approve ? <span style={{ color: 'red' }}>*</span> : '(optional)'}</label>
                                                    <input type="number" min="0" className="form-control" value={this.state.reviewNdvAmount} onChange={this.onChangeReviewNdvAmount} disabled={this.state.reviewSubmitting} />
                                                    <small className="form-text text-muted">
                                                        This confirmation was submitted before dealer-entered NDV existed - enter the amount to classify it.
                                                        &le; Rs. {options.ndv_credit_note_max} routes to Credit Note; above routes to COF.
                                                    </small>
                                                </div>
                                            }
                                        </div>
                                        : null}
                                    <div className="form-group mb-1">
                                        <label>Remarks {this.state.reviewAction === 'reject' && options.require_reject_remarks ? <span style={{ color: 'red' }}>*</span> : '(optional)'}</label>
                                        <textarea className="form-control" rows="3" maxLength={options.max_remarks_length}
                                            value={this.state.reviewRemarks} onChange={this.onChangeReviewRemarks}
                                            disabled={this.state.reviewSubmitting} placeholder={this.state.reviewAction === 'reject' ? 'Why is this NDV being rejected?' : 'Optional notes'} autoFocus />
                                    </div>
                                    {this.state.reviewError ? <div className="text-danger mb-1">{this.state.reviewError}</div> : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.onCancelReview} disabled={this.state.reviewSubmitting}>Cancel</button>
                                    <button type="button" className={this.state.reviewAction === 'approve' ? 'btn btn-success' : 'btn btn-danger'} onClick={this.onConfirmReview} disabled={this.state.reviewSubmitting}>
                                        {this.state.reviewSubmitting ? 'Submitting...' : (this.state.reviewAction === 'approve' ? 'Approve' : 'Reject')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}

                {/* Action 19 - Signed document upload modal */}
                {this.state.signedUploadModalShow ?
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        onClick={this.onCancelSignedUpload}>
                        <div className="modal-dialog" style={{ maxWidth: 480, width: '90%', margin: 0 }} onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Upload Signed Document</h5>
                                    <button type="button" className="close" onClick={this.onCancelSignedUpload} disabled={this.state.signedUploadSubmitting}><span>&times;</span></button>
                                </div>
                                <div className="modal-body">
                                    {this.state.signedUploadRow ? <p className="mb-2"><b>GC/Way Bill No:</b> {this.state.signedUploadRow.gc_waybill_no}</p> : null}
                                    <div className="alert alert-warning py-1 px-2 mb-2" style={{ fontSize: '12px' }}>
                                        Only the LR's own transporter (LSP) may upload the signed document, within {options.signed_upload.window_text || (options.signed_upload.window_days + ' day(s)')} of generation. The backend re-validates this regardless of what this screen shows.
                                    </div>
                                    <div className="form-group mb-1">
                                        <label>Signed Document <span style={{ color: 'red' }}>*</span></label>
                                        <input type="file" className="form-control" accept={(options.signed_upload.allowed_mime_types || []).join(',')}
                                            onChange={this.onChangeSignedFile} disabled={this.state.signedUploadSubmitting} />
                                        <small className="form-text text-muted">Max {options.signed_upload.max_size_mb} MB.</small>
                                    </div>
                                    {this.state.signedUploadError ? <div className="text-danger mb-1">{this.state.signedUploadError}</div> : null}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.onCancelSignedUpload} disabled={this.state.signedUploadSubmitting}>Cancel</button>
                                    <button type="button" className="btn btn-warning" onClick={this.onConfirmSignedUpload} disabled={this.state.signedUploadSubmitting}>
                                        {this.state.signedUploadSubmitting ? 'Uploading...' : 'Upload'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : null}
            </div>
        );
    }
}
